<ng-container content *ngIf="languageStore.state$ | async as languageState">
  <vi-page
    data-at-settings-page
    [sidenavs]="true"
    [footer]="true"
    [isWhiteBackground]="true"
    [shadowHead]="false"
  >
    <app-downtime-notification head></app-downtime-notification>
    <app-callback-notification head></app-callback-notification>
    <vi-toolbar head color="white">
      <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="settings"></vi-back-button>
      <vi-breadcrumbs
        left
        gtm="onBreadcrumb"
        gtmCategory="settings"
        formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
        currentPage="{{ 'GENERAL.PATH.SETTINGS' | translate }}"
        [navigateTo]="'/installations'"
      ></vi-breadcrumbs>
    </vi-toolbar>

    <div head class="setting-title-wrapper" data-at-bar-message>
      <h1 data-at-title>
        {{ '+SETTINGS.TITILE' | translate }}
      </h1>
    </div>

    <div body>
      <div
        *ngIf="
          !(notificationsStore.loading$ | async) && !(unitsStore.loading$ | async);
          else loader
        "
        content
        class="grid"
      >
        <div class="grid-item" *ngIf="notificationsStore.loaded$ | async">
          <div>
            <span class="grid-item-title">{{ '+SETTINGS.NOTIFICATIONS.TITLE' | translate }}</span>
            <span class="grid-item-description">{{
              '+SETTINGS.NOTIFICATIONS.DESCRIPTION'
                | translate: { email: (notificationsStore.email$ | async) }
            }}</span>
          </div>
          <app-setting
            *ngrxLet="notificationsStore.notificationsEnabled$ as currentValue"
            data-at-notifications-setting
            [options]="[
              {
                value: settingsPreferenceOption.On,
                viewValue: 'GENERAL.ON' | translate,
                additionalOption: '+SETTINGS.NOTIFICATION_SETTINGS_EDIT' | translate,
                additionalOptionEnabled: authStore.hasAccessToNotificationSettings$ | async
              },
              {
                value: settingsPreferenceOption.Off,
                viewValue: 'GENERAL.OFF' | translate
              }
            ]"
            [currentValue]="
              currentValue === true ? settingsPreferenceOption.On : settingsPreferenceOption.Off
            "
            (valueChange)="valueChangeHandler($event, settingsPreference.Notifications)"
            (additionalOptionSelected)="onEditRecipients()"
          ></app-setting>
        </div>

        <div class="grid-item">
          <div>
            <span class="grid-item-title">{{ '+SETTINGS.LANGUAGE.TITLE' | translate }}</span>
            <span class="grid-item-description">{{
              '+SETTINGS.LANGUAGE.DESCRIPTION' | translate
            }}</span>
          </div>
          <app-language-setting
            [value]="languageState.languageCode"
            (valueChange)="languageStore.setLanguage($event)"
          >
          </app-language-setting>
        </div>

        <ng-container *ngrxLet="unitsStore.settingsPreferences$ as preferences">
          <div class="grid-item">
            <div>
              <span class="grid-item-title">{{
                '+SETTINGS.UNITS.TEMPERATURE_TITLE' | translate
              }}</span>
              <span class="grid-item-description">{{
                '+SETTINGS.UNITS.TEMPERATRE_DESCRIPTION' | translate
              }}</span>
            </div>
            <app-setting
              data-at-units-setting="temperature"
              [attr.data-at-value]="preferences.temperature"
              [options]="[
                {
                  value: settingsPreferenceOption.Celsius,
                  viewValue: '+SETTINGS.UNITS.BUTTON.CELSIUS' | translate,
                },
                {
                  value: settingsPreferenceOption.Fahrenheit,
                  viewValue: '+SETTINGS.UNITS.BUTTON.FAHRENHEIT' | translate
                }
              ]"
              [currentValue]="preferences.temperature"
              (valueChange)="valueChangeHandler($event, settingsPreference.Temperature)"
            ></app-setting>
          </div>

          <div class="grid-item">
            <div>
              <span class="grid-item-title">{{
                '+SETTINGS.UNITS.FLOW_RATE_TITLE' | translate
              }}</span>
              <span class="grid-item-description">{{
                '+SETTINGS.UNITS.FLOW_RATE_DESCRIPTION' | translate
              }}</span>
            </div>
            <app-setting
              data-at-units-setting="flowRate"
              [options]="[
                {
                  value: settingsPreferenceOption.LiterPerHour,
                  viewValue: '+SETTINGS.UNITS.BUTTON.LITER_PER_HOUR' | translate,
                },
                {
                  value: settingsPreferenceOption.GallonPerMinute,
                  viewValue: '+SETTINGS.UNITS.BUTTON.GALLON_PER_MINUTE' | translate
                }
              ]"
              [currentValue]="preferences.flowRate"
              (valueChange)="valueChangeHandler($event, settingsPreference.FlowRate)"
            ></app-setting>
          </div>

          <div class="grid-item">
            <div>
              <span class="grid-item-title">{{ '+SETTINGS.UNITS.VOLUME_TITLE' | translate }}</span>
              <span class="grid-item-description">{{
                '+SETTINGS.UNITS.VOLUME_DESCRIPTION' | translate
              }}</span>
            </div>
            <app-setting
              data-at-units-setting="volume"
              [options]="[
                {
                  value: settingsPreferenceOption.CubicMeter,
                  viewValue: '+SETTINGS.UNITS.BUTTON.CUBIC_METER' | translate,
                },
                {
                  value: settingsPreferenceOption.CubicFeet,
                  viewValue: '+SETTINGS.UNITS.BUTTON.CUBIC_FEET' | translate
                }
              ]"
              [currentValue]="preferences.volume"
              (valueChange)="valueChangeHandler($event, settingsPreference.Volume)"
            ></app-setting>
          </div>

          <div class="grid-item">
            <div>
              <span class="grid-item-title">{{
                '+SETTINGS.UNITS.PRESSURE_TITLE' | translate
              }}</span>
              <span class="grid-item-description">{{
                '+SETTINGS.UNITS.PRESSURE_DESCRIPTION' | translate
              }}</span>
            </div>
            <app-setting
              data-at-units-setting="pressure"
              [options]="[
                {
                  value: settingsPreferenceOption.Bar,
                  viewValue: '+SETTINGS.UNITS.BUTTON.BAR' | translate,
                },
                {
                  value: settingsPreferenceOption.PoundPerSquareInch,
                  viewValue: '+SETTINGS.UNITS.BUTTON.POUND_PER_SQUARE_INCH' | translate
                }
              ]"
              [currentValue]="preferences.pressure"
              (valueChange)="valueChangeHandler($event, settingsPreference.Pressure)"
            ></app-setting>
          </div>
        </ng-container>
      </div>

      <ng-template #loader>
        <vi-loader
          main
          data-at-loader
          [isLoading]="true"
          message="{{ '+SETTINGS.LOADING_MESSAGE' | translate }}"
        ></vi-loader>
      </ng-template>
    </div>

    <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
    <app-sidenav left-sidenav></app-sidenav>
  </vi-page>
</ng-container>
